import { Component, Input, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { DecimalFormatPipe } from 'app/shared/pipes';

@Component({
    selector: 'sgt-perc-crescimento-icon',
    templateUrl: './perc-crescimento-icon.component.html',
    styleUrls: ['./perc-crescimento-icon.component.less']
})
export class PercCrescimentoIconComponent implements OnInit, OnChanges {
    @Input() percCrescimento: number;
    @Input() minFractionDigits = 2;
    @Input() maxFractionDigits = 2;
    @Input() quedaLabel = 'Queda de';
    @Input() manteveLabel = 'Manteve';
    @Input() aumentoLabel = 'Aumento de';
    @Input() emRelacaoLabel = 'em relação ao mês anterior';

    title: string;

    constructor(private decimalFormat: DecimalFormatPipe) {}

    ngOnInit(): void {
        this.createTitle();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'percCrescimento') {
                this.createTitle();
            }
        }
    }

    private createTitle() {
        if (this.percCrescimento < 0) {
            this.title = `${this.quedaLabel} ${this.decimalFormat.transform(this.percCrescimento, 1, this.minFractionDigits, this.maxFractionDigits)}% ${this.emRelacaoLabel}`;
        } else if (this.percCrescimento == 0) {
            this.title = `${this.manteveLabel} ${this.emRelacaoLabel}`;
        } else {
            this.title = `${this.aumentoLabel} ${this.decimalFormat.transform(this.percCrescimento,1, this.minFractionDigits, this.maxFractionDigits)}% ${this.emRelacaoLabel}`;
        }
    }

}
